/**
 * Email read from a URL query string. Legacy links omitted encoding, so "+" (e.g. Gmail
 * sub-addressing) was decoded as a space and failed API validation.
 */
export function emailFromQueryParam(raw) {
  if (!raw || !raw.includes("@")) return raw;
  const at = raw.lastIndexOf("@");
  const local = raw.slice(0, at);
  const domain = raw.slice(at + 1);
  if (!local.includes("+") && /\s/.test(local)) {
    return `${local.replace(/\s/g, "+")}@${domain}`;
  }
  return raw;
}
